// extracted by mini-css-extract-plugin
export default {"header":"style_header__R9dS-","wrapper":"style_wrapper__642vQ","avatarCloud":"style_avatarCloud__V0GRP","avatar":"style_avatar__r7Vdg","avatarInner":"style_avatarInner__OH530"};